import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */
import { ResizableBox } from '@wordpress/components';

/**
 * Internal dependencies
 */
import BlockPopover from '../block-popover';
export default function ResizableBoxPopover({
  clientId,
  resizableBoxProps,
  ...props
}) {
  return createElement(BlockPopover, {
    clientId: clientId,
    __unstableCoverTarget: true,
    __unstablePopoverSlot: "block-toolbar",
    shift: false,
    ...props
  }, createElement(ResizableBox, {
    ...resizableBoxProps
  }));
}
//# sourceMappingURL=index.js.map